export enum CartMutationTypes{
    SET_CART_ITEMS='SET_CART_ITEM',
    PUSH_PRODUCT_CART='PUSH_PRODUCT_CART',
    SET_ACTIVE_ORDER='SET_ACTIVE_ORDER',
    RESET_ACTIVE_ORDER='RESET_ACTIVE_ORDER',
    SET_CHECKOUT_STATUS='SET_CHECKOUT_STATUS',
    SET_SELECT_SHIPPING_METHOD='SET_SELECT_SHIPPING_METHOD',
    SET_FETCHED_SHIPPING_METHODS='SET_FETCHED_SHIPPING_METHODS',
    UNSET_CART_ITEMS='UNSET_CART_ITEMS'
}